import { useEffect, useState } from "react";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import LoadingSpinner from "src/components/Loader/LoadingSpinner";
import { usePayoutConfirmationMutation } from "src/lib/endpoints/wallet/wallet.api";
import { selectUserState } from "src/lib/features/auth/authSlice";
import { useTypedSelector } from "src/lib/store/store";

const WalletConfirmation = () => {
  const { confirmPayout, isLoading, data } = usePayoutConfirmationMutation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isSubmitting, setIsSubmitting] = useState(true);

  useEffect(() => {
    if (!searchParams.get("confirmation_token")) return;

    const formData = new FormData();
    formData.append(
      "confirmation_token",
      searchParams.get("confirmation_token") ?? ""
    );

    confirmPayout(formData, {
      onSuccess: (res) => {
        setIsSubmitting(false);
      },
      onError: (error: any) => {
        setIsSubmitting(false);
      },
    });
  }, [searchParams]);

  return (
    <div className="mt-10 flex flex-col justify-center items-center">
      {isSubmitting ? (
        <div className="flex flex-col space-y-3 min-h-[70vh] w-full items-center justify-center">
          <LoadingSpinner />
          <p>Your withdrawal request is being processed</p>
        </div>
      ) : !data?.status ? (
        <div className="flex flex-col space-y-3 min-h-[70vh] w-full items-center justify-center">
          <p className="font-medium text-lg">{data?.message}</p>
          <p>Click the link below to go back to Dashboard</p>
          <Link
            to="/"
            className="underline underline-offset-2 font-bold italic"
          >
            Continue
          </Link>
        </div>
      ) : (
        <div className="flex flex-col space-y-3 min-h-[70vh] w-full items-center justify-center">
          <p>Your request has been submitted</p>
          <p>
            Click the link below to go back to Dashboard request has been
            submitted
          </p>
          <Link
            to="/"
            className="underline underline-offset-2 font-bold italic"
          >
            Continue
          </Link>
        </div>
      )}
    </div>
  );
};

export default WalletConfirmation;
